import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { EstimateForm } from './EstimateForm';
import { OpenStatus } from './OpenStatus';
import { hours, shop } from '../data/shop';
import { formatHoursRange } from '../utils/hours';
export function EstimateSection() {
  const todayIndex = new Date().getDay();
  return <section id="estimate" aria-labelledby="estimate-heading" className="bg-ink py-20 text-white lg:py-28" data-id="element-103" data-mp="1q4831g8jec69">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-8" data-id="element-104" data-mp="1uzx63tjrmb7b">
        <div className="lg:col-span-5" data-id="element-105" data-mp="1z1s7sz5lyqlm">
          <p className="mb-3 text-sm font-semibold text-white/70" data-id="element-106" data-mp="23ul737ib56qb">Contact</p>
          <h2 id="estimate-heading" className="font-display text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-107" data-mp="23wo080erbfz9">
            Get a free estimate
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-white/75" data-id="element-108" data-mp="2dtslzz4ox9fj">
            Send a few details and photos and we'll get back to you with a ballpark and next steps. Prefer to talk?
            Call or stop by — no appointment needed for estimates.
          </p>

          <ul className="mt-10 space-y-5" data-id="element-109" data-mp="1kkclpm2fnpr8">
            <li data-id="element-110" data-mp="1kjazclfyvgu7">
              <a href={shop.phoneHref} className="group flex items-center gap-4" data-id="element-111" data-mp="1kmyu1nx5e9ai">
                <PhoneIcon className="h-5 w-5 text-white/50" aria-hidden="true" data-id="element-112" data-mp="1fmb0auhjbecl" />
                <span className="font-display text-xl font-bold group-hover:underline group-hover:underline-offset-4" data-id="element-113" data-mp="1blit06s83jiy">
                  {shop.phone}
                </span>
              </a>
            </li>
            <li data-id="element-114" data-mp="23cooub0wuv2f">
              <a href={shop.mapsHref} target="_blank" rel="noreferrer" className="group flex items-start gap-4" data-id="element-115" data-mp="23c5cd9u14yvs">
                <MapPinIcon className="mt-0.5 h-5 w-5 text-white/50" aria-hidden="true" data-id="element-116" data-mp="1yial9lc3hhmo" />
                <span className="text-white/90 group-hover:underline group-hover:underline-offset-4" data-id="element-117" data-mp="1ugz6kauregt9">
                  {shop.addressLine1}
                  <br data-id="element-118" data-mp="2m9prhp6zsj37" />
                  {shop.addressLine2}
                </span>
              </a>
            </li>
            <li data-id="element-119" data-mp="kdqo7e84bb6r">
              <a href={`mailto:${shop.email}`} className="group flex items-center gap-4" data-id="element-120" data-mp="kd7iqwznmf9m">
                <MailIcon className="h-5 w-5 text-white/50" aria-hidden="true" data-id="element-121" data-mp="pah523rqyat8" />
                <span className="break-all text-white/90 group-hover:underline group-hover:underline-offset-4" data-id="element-122" data-mp="annxjkogy9bl">
                  {shop.email}
                </span>
              </a>
            </li>
          </ul>

          <div className="mt-12 border-t border-white/15 pt-8" data-id="element-123" data-mp="1leo6y4xslzs">
            <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-124" data-mp="6l14jgg2aict">
              <h3 className="font-display text-lg font-bold" data-id="element-125" data-mp="3ntfng0tpvnwj">Shop hours</h3>
              <OpenStatus tone="light" data-id="element-126" data-mp="3nv8yrtf9ywav" />
            </div>
            <dl className="mt-5 space-y-2.5 text-sm" data-id="element-127" data-mp="3srplqkaqn4md">
              {hours.map(day => {
              const isToday = day.dayIndex === todayIndex;
              return <div key={day.day} className={`flex justify-between gap-4 ${isToday ? 'font-semibold text-white' : 'text-white/65'}`} data-id="element-128" data-mp="1r0w29lxmq393">
                    <dt data-id="element-129" data-mp="36kdey62992k4">
                      {day.day}
                      {isToday && <span className="sr-only" data-id="element-130" data-mp="36i0pz8y2xrxk"> (today)</span>}
                    </dt>
                    <dd data-id="element-131" data-mp="3laaww49lcw0v">{formatHoursRange(day)}</dd>
                  </div>;
            })}
            </dl>
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-132" data-mp="3u8wn8llb1fc7">
          <EstimateForm data-id="element-133" data-mp="3u7uzphn3r0dl" />
        </div>
      </div>
    </section>;
}